import { loadOauthToken } from "./fetchToken";
import { getTokenCookie, updateTokenCookie } from "./updateCookie";

export const getToken = async (defaultLocale: string): Promise<string | null> => {
  const tokenFromCookie = getTokenCookie();
  if (tokenFromCookie) {
    return tokenFromCookie;
  }
  const tokenData = await loadOauthToken(defaultLocale);
  if (tokenData?.data?.accessToken && tokenData?.data?.expiresIn) {
    updateTokenCookie(tokenData.data);
    return tokenData?.data?.accessToken;
  }

  return null;
};
